var map = {
	"./P1_side_right2.png": "Dlnh",
	"./P2_side_right2.png": "E5gc"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "+h7G";


//////////////////
// WEBPACK FOOTER
// ./src/assets/parts/UST ^\.\/.*_side_right2\.png$
// module id = +h7G
// module chunks = 3